<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import VueCropper from 'vue-cropperjs';
    
   export default {
      page: {
         title: "Edit Clinic",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader, VueCropper },
      data() {
         return {
            title: "Edit Clinic",
            items: [
               {
                  text: "Clinics",
                  href: "/clinics",
               },
               {
                  text: "Edit Clinic",
                  active: true,
               },        
            ],


            clinic: { 
              
            },
            countries: [],

            clinic_location: '',
            clinic_marker: { position: { lat: null, lng: null } },
            clinic_center: { lat: null, lng: null },
            clinic_current_place: null,

            clinic_mapOptions: {
               disableDefaultUI: true,
            },

            errors: {},
            password: '',
            password_confirmation: '',
            image: "",
            preview_image: "",
            showCropper: false,
            cropperImage: "",
            cropperOptions: {
               aspectRatio: 1,
               viewMode: 1,
               dragMode: 'move',
               autoCropArea: 0.8,
               restore: false,
               guides: false,
               center: false,
               highlight: false,
               cropBoxMovable: true,
               cropBoxResizable: true,
               toggleDragModeOnDblclick: false,
            },
            isSquareCrop: true,
            
            loading: false,
         };
      },
      mounted() {
    
      },

      created() {
         this.fetchClinic();
      },

      beforeDestroy() {
         // Clean up object URLs to prevent memory leaks
         if (this.cropperImage) {
            URL.revokeObjectURL(this.cropperImage);
         }
         if (this.preview_image) {
            URL.revokeObjectURL(this.preview_image);
         }
      },

      methods: {

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },

         alphaSpacesOnly(event) {
            let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32)) {
                 return;
            } else {
               event.preventDefault();
            }
         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },

         fetchClinic() {
            let url = "api/admin/clinics/details?id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.clinic = responseData.clinic;  

               this.clinic_marker.position.lat = this.clinic.latitude;
               this.clinic_marker.position.lng = this.clinic.longitude;

               this.clinic_center.lat = this.clinic.latitude;
               this.clinic_center.lng = this.clinic.longitude;

               this.fetchCountryCodes();

            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },
         //sets the position of marker when dragged
         clinicHandleMarkerDrag(e) {
            this.clinic_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
         },

         //Moves the map view port to marker
         clinicPanToMarker() {
            this.$refs.clinicMapRef.panTo(this.clinic_marker.position);
            this.$refs.clinicMapRef.setZoom(18);
         },

         //Moves the marker to click position on the map
         clinicHandleMapClick(e) {
            this.clinic_marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
         },     

         clinicSetPlace(place) {
            this.clinic_current_place = place;
            if(this.clinic_current_place) {
               const marker = {
                  lat: this.clinic_current_place.geometry.location.lat(),
                  lng: this.clinic_current_place.geometry.location.lng(),
               };
               this.clinic_center = marker;
               this.clinic_marker.position = marker;
               this.clinic_location = place.formatted_address;
            }
         },
         setFile(e) {
            const file = e.target.files[0];
            if (file) {
               // Validate file type
               const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];
               if (!allowedTypes.includes(file.type)) {
                  this.$swal("", "Please select a valid image file (JPG, JPEG, PNG)", "error");
                  return;
               }
               
               // Validate file size (max 5MB)
               if (file.size > 5 * 1024 * 1024) {
                  this.$swal("", "Image size should be less than 5MB", "error");
                  return;
               }
               
               this.cropperImage = URL.createObjectURL(file);
               this.showCropper = true;
            }
         },

         cropImage() {
            // Get cropped canvas
            const canvas = this.$refs.cropper.getCroppedCanvas({
               width: 400,
               height: 400,
               imageSmoothingEnabled: true,
               imageSmoothingQuality: 'high',
            });
            
            // Convert canvas to blob
            canvas.toBlob((blob) => {
               // Create a new file from the blob
               const croppedFile = new File([blob], 'cropped-image.jpg', {
                  type: 'image/jpeg',
                  lastModified: Date.now()
               });
               
               this.image = croppedFile;
               this.preview_image = URL.createObjectURL(blob);
               this.showCropper = false;
               
               // Clean up the cropper image URL
               if (this.cropperImage) {
                  URL.revokeObjectURL(this.cropperImage);
                  this.cropperImage = "";
               }
            }, 'image/jpeg', 0.9);
         },

         cancelCrop() {
            this.showCropper = false;
            // Clean up the cropper image URL
            if (this.cropperImage) {
               URL.revokeObjectURL(this.cropperImage);
               this.cropperImage = "";
            }
            // Reset file input
            this.$refs.fileInput.value = '';
            // Reset preview image to show original image again
            if (this.preview_image) {
               URL.revokeObjectURL(this.preview_image);
               this.preview_image = "";
            }
         },

         toggleAspectRatio() {
            this.isSquareCrop = !this.isSquareCrop;
            this.cropperOptions.aspectRatio = this.isSquareCrop ? 1 : NaN;
            if (this.$refs.cropper) {
               this.$refs.cropper.setAspectRatio(this.cropperOptions.aspectRatio);
            }
         },
         updatePassword() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/clinics/password/change";

            let formData = new FormData();
            formData.append("id", this.$route.params.id); 
            formData.append("password", this.password); 
            formData.append("password_confirmation", this.password_confirmation); 
            
            this.loading = true;
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
               if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'clinics'});
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         updateClinic() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/clinics/edit_new";

            let formData = new FormData();
            formData.append("clinic_id", this.clinic.clinic_id); 
            formData.append("name", this.clinic.name); 
            formData.append("place", this.clinic.place); 
            formData.append("country_code", this.clinic.country_code_id); 
            formData.append("phone", this.clinic.mobile); 
            formData.append("latitude", this.clinic_marker.position.lat); 
            formData.append("longitude", this.clinic_marker.position.lng); 
            formData.append("username", this.clinic.username); 
            formData.append("display_time", this.clinic.display_token_time); 
            formData.append("display_name", this.clinic.display_name); 
            formData.append("unlist", this.clinic.unlist); 
            if(this.image) {
               formData.append('image', this.image);
            }
            
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'clinics'});
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        if(error.response.status == 422);{
                           this.$nextTick(() => {
                              const firstErrorField = document.querySelector('.is-invalid');
                              if (firstErrorField) {
                                 firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                 firstErrorField.focus();
                              }
                           });
                        }
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },
      }
   }
</script>

<style scoped>
   .page-loader {
      display: flex;
      align-items: center;
      padding: 10px 0;
   }

   .page-loader img {
      width: 50px;
      height: 50px;
   }
</style>

    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'clinics' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="updateClinic()">
                        
                        <div class="row">
                           
                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Name<span class="text-danger">*</span></label>
                              <b-form-input v-model="clinic.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"></b-form-input>
                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Place<span class="text-danger">*</span></label>
                              <b-form-input v-model="clinic.place" v-bind:class="{ 'is-invalid': Boolean(errors.place) }"></b-form-input>
                              <div v-for="(val, index) in errors.place" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Mobile <span class="text-danger">*</span></label>
                              <b-input-group v-bind:class="{ 'is-invalid': Boolean(errors.phone) }">
                                 <b-input-group-prepend>
                                    <select class="form-control" v-model="clinic.country_code_id">
                                       <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                    </select>
                                 </b-input-group-prepend>
                                 <b-form-input v-model="clinic.mobile" @keypress="numbersOnly" maxlength="15"></b-form-input>
                                 <div v-for="(val, index) in errors.phone" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-input-group>

                              
                           </b-form-group>

                           <b-col md="12" lg="6" class="form-group">
                              <label class="control-label">Email<span class="text-danger">*</span></label>
                              <b-form-input type="email" v-model="clinic.username" v-bind:class="{ 'is-invalid': Boolean(errors.username) }"></b-form-input>
                              <div v-for="(val, index) in errors.username" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                           <b-card header-class="bg-transparent border-light" class="border border-light">
                           <label>Profile Image <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png, Max size: 5MB]</span></label>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 
                                  <img v-if="clinic.image && !preview_image" :src="$image_url + clinic.image" class="avatar-sm mb-2" alt="" />
                           
                           <!-- Preview of new/cropped image -->
                           <div v-if="preview_image" class="mt-2">
                              <img class="avatar-sm" :src="preview_image" alt="New Profile Preview">
                              <p class="text-muted small mt-1">New image preview - Click "Choose File" to select a different image</p>
                           </div>
                           
                           <input ref="fileinput" type="file" @change="setFile($event)" accept="image/*" class="form-control image-class"  v-bind:class="{ 'is-invalid': Boolean(errors.image) }"/>
                           
                           <div class="note">Leave this field empty if you don't want to add/edit the image</div>

                           <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                                 
                              </div>
                              
                           </div>
                        </b-card>

                           <b-col md="12" class="mb-3">
                              <label class="control-label">Location</label>
                              <GmapAutocomplete @place_changed="clinicSetPlace" class="form-control"  @keypress.enter="$event.preventDefault()" placeholder="Search here to pick the required latitude and longitude..."  :value="clinic_location"/>
                              <p class="small">Leave this empty if you don't want to change the latitude and longitude</p>

                              <!-- <div v-if="clinic_center.lat!=null"> -->
                              <GmapMap v-if="clinic_location"
                                 :center="clinic_center"
                                 :zoom="18"
                                 map-style-id="clinic-roadmap"
                                 :options="clinic_mapOptions"
                                 style="width: 100%; height: 50vmin"
                                 ref="clinicMapRef"
                                 @click="clinicHandleMapClick">
                                    <GmapMarker
                                       :position="clinic_marker.position"
                                       :clickable="true"
                                       :draggable="true"
                                       @drag="clinicHandleMarkerDrag"
                                       @click="clinicPanToMarker"
                                    />
                              </GmapMap>   
                              <!-- </div>     -->                   
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Latitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="clinic_marker.position.lat" type="number" step="any" :class="{ 'is-invalid': Boolean(errors.latitude) }"></b-form-input>

                              <div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                              
                           </b-col>

                           <b-col md="6" xl="6" class="form-group">
                              <label class="control-label">Longitude <span class="text-danger">*</span></label>
                              <b-form-input v-model="clinic_marker.position.lng" type="number" step="any" :class="{ 'is-invalid': Boolean(errors.longitude) }"></b-form-input>
                              
                              <div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>
                        <div class="row">
                           <div class="form-group col-md-3">
                              <b-form-checkbox
                                 v-model="clinic.display_token_time"
                                 name="display_token_time"
                                 value="1"
                                 unchecked-value="2"
                              >
                                 <span class="ms-2">Display Time (TVM)</span>
                              </b-form-checkbox>
                           </div>
                           <div class="form-group col-md-3">
                              <b-form-checkbox
                                 v-model="clinic.display_name"
                                 name="display_name"
                                 value="1"
                                 unchecked-value="2"
                              >
                                 <span class="ms-2">Display Name (TVM)</span>
                              </b-form-checkbox>
                           </div>
                           <div class="form-group col-md-3">
                              <b-form-checkbox
                                 v-model="clinic.unlist"
                                 name="unlist"
                                 value="1"
                                 unchecked-value="2"
                              >
                                 <span class="ms-2">Unlist from Clinics</span>
                              </b-form-checkbox>
                           </div>
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <div v-if="loading" class="page-loader">
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                              <div v-else>
                                 <button class="btn btn-primary me-2" type="submit">Update</button>
                                 <router-link :to="{ name: 'clinics' }" class="btn btn-light">Cancel</router-link>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="updatePassword()">
                        <h4 class="font-size-16 mb-4">Change Password</h4>
                        <div class="row">

                           <b-col md="12" lg="6" class="form-group" >
                              <!-- <label class="control-label">Password<span class="text-danger">*</span></label> -->
                              <label class="control-label">New Password<span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="password"  v-bind:class="{ 'is-invalid': Boolean(errors.password) }"></b-form-input>

                              <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>

                           <b-col md="12" lg="6" class="form-group" >
                              <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                              <b-form-input type="password" v-model="password_confirmation"  v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"></b-form-input>

                              <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-col>
                        </div>

                        <div class="row mt-3">
                           <div class="12">
                              <div v-if="loading" class="page-loader">
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                              <div v-else>
                                 <button class="btn btn-primary me-2" type="submit">Update</button>
                                 <router-link :to="{ name: 'clinics' }" class="btn btn-light">Cancel</router-link>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>

      <!-- Image Cropper Modal -->
      <b-modal 
         v-model="showCropper" 
         title="Crop Profile Image" 
         size="lg" 
         centered 
         hide-footer
         @hide="cancelCrop"
         no-close-on-backdrop
         no-close-on-esc
         class="cropper-modal">
         
         <div class="cropper-container">
            <vue-cropper
               ref="cropper"
               :src="cropperImage"
               :aspect-ratio="cropperOptions.aspectRatio"
               :view-mode="cropperOptions.viewMode"
               :drag-mode="cropperOptions.dragMode"
               :auto-crop-area="cropperOptions.autoCropArea"
               :restore="cropperOptions.restore"
               :guides="cropperOptions.guides"
               :center="cropperOptions.center"
               :highlight="cropperOptions.highlight"
               :crop-box-movable="cropperOptions.cropBoxMovable"
               :crop-box-resizable="cropperOptions.cropBoxResizable"
               :toggle-drag-mode-on-dblclick="cropperOptions.toggleDragModeOnDblclick"
               class="cropper-wrapper">
            </vue-cropper>
         </div>
         
         <div class="cropper-controls mt-3">
            <div class="d-flex justify-content-between align-items-center">
               <div>
                  <button type="button" class="btn btn-outline-primary btn-sm" @click="toggleAspectRatio">
                     <i class="bx bx-crop"></i> 
                     {{ isSquareCrop ? 'Free Ratio' : 'Square Crop' }}
                  </button>
               </div>
               <div>
                  <button type="button" class="btn btn-secondary me-2" @click="cancelCrop">
                     <i class="bx bx-x"></i> Cancel
                  </button>
                  <button type="button" class="btn btn-primary" @click="cropImage">
                     <i class="bx bx-check"></i> Crop & Save
                  </button>
               </div>
            </div>
         </div>
      </b-modal>
   </Layout>
</template>

<style scoped>
.cropper-container {
   height: 400px;
   width: 100%;
}

.cropper-wrapper {
   height: 100%;
   width: 100%;
}

.cropper-controls {
   border-top: 1px solid #e9ecef;
   padding-top: 1rem;
}

.avatar-sm {
   width: 80px;
   height: 80px;
   object-fit: cover;
   border-radius: 8px;
   border: 2px solid #e9ecef;
}

.avatar-md {
   width: 120px;
   height: 120px;
   object-fit: cover;
   border-radius: 8px;
   border: 2px solid #e9ecef;
}

/* Cropper modal specific styles */
.cropper-modal .modal-dialog {
   max-width: 800px;
}

.cropper-modal .modal-body {
   padding: 1rem;
}
</style>
